import { useMutation } from '@tanstack/react-query';

import {
  downloadExpiringCreditsReport,
  downloadOutsidePolicyDatesRequestsReport,
  downloadRefundRequestsReport,
  queueCustomLincBookingsReport,
  queueCustomLincPayableReport,
  queueMusementBookingsReport,
  queueMusementPayableReport,
} from '~/services/ReportingService';

interface DownloadExpiringCreditsReportParams {
  startAt: string;
  endAt: string;
  minimumCreditsValue: number;
}

interface QueueReportParams {
  startAt: string;
  endAt: string;
  format: 'csv' | 'email';
}

export function useQueueCustomLincBookingsReport() {
  return useMutation({
    mutationFn: async (params: QueueReportParams) => {
      return await queueCustomLincBookingsReport(params);
    },
  });
}

export function useQueueCustomLincPayableReport() {
  return useMutation({
    mutationFn: async (params: QueueReportParams) => {
      return await queueCustomLincPayableReport(params);
    },
  });
}

export function useDownloadExpiringCreditsReport() {
  return useMutation({
    mutationFn: async (params: DownloadExpiringCreditsReportParams) => {
      return await downloadExpiringCreditsReport(params);
    },
  });
}

export function useQueueMusementBookingsReport() {
  return useMutation({
    mutationFn: async (params: QueueReportParams) => {
      return await queueMusementBookingsReport(params);
    },
  });
}

export function useQueueMusementPayableReport() {
  return useMutation({
    mutationFn: async (params: QueueReportParams) => {
      return await queueMusementPayableReport(params);
    },
  });
}

interface DateRangeReportParams {
  startAt: string;
  endAt: string;
}

export function useDownloadRefundRequestsReport() {
  return useMutation({
    mutationFn: async (params: DateRangeReportParams) => {
      return await downloadRefundRequestsReport(params);
    },
  });
}

export function useDownloadOutsidePolicyDatesRequestsReport() {
  return useMutation({
    mutationFn: async (params: DateRangeReportParams) => {
      return await downloadOutsidePolicyDatesRequestsReport(params);
    },
  });
}
